import classNames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

export type ContactCardLineProps<TValue = string> = {
    show?: boolean;
    value?: TValue;
    formatter?: (v: TValue) => React.ReactNode;
    screenReaderLabel?: string;
    icon?: IconTypes;
    placeholder?: string;
} & React.PropsWithoutRef<JSX.IntrinsicElements['dl']>;

function defaultFormatter<TValue = string>(value: TValue) {
    return <span>{String(value)}</span>;
}

function ContactCardLine<TValue = string>({
    show = true,
    icon,
    value,
    formatter = defaultFormatter,
    screenReaderLabel,
    className,
    placeholder,
    ...rest
}: ContactCardLineProps<TValue>) {
    if (!show) return <></>;
    return (
        <dl className={classNames('sgw-contact-card__line', className)} {...rest}>
            <dt className="sgw-contact-card__line-label">
                <span className="screen-reader-text">{screenReaderLabel}</span>
                {icon && <Icon type={icon} />}
            </dt>
            <dd className={classNames('sgw-contact-card__line-value', { empty: !value && !!placeholder })}>
                {value ? formatter(value) : placeholder}
            </dd>
        </dl>
    );
}

export default ContactCardLine;
